import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            toastType: (state) => state.message.type,
            toastMessage: (state) => state.message.message,
            alertType: (state) => state.alert.type,
            alertMessage: (state) => state.alert.message,
        }),
    },
    watch: {
        toastMessage: function (newVal) {
            if (newVal) {
                this.$bvToast.toast(newVal, {
                    variant: this.toastType,
                    solid: true,
                    toaster: 'b-toaster-top-center',
                    bodyClass: 'text-break',
                });
                this.$store.commit('message/setMessage', '');
            }
        },
        alertMessage: function (newVal) {
            if (newVal) {
                const type =
                    this.alertType === 'danger' ? 'error' : this.alertType;
                this.$swal({
                    title: newVal,
                    icon: type,
                    showConfirmButton: false,
                    timer: 3500,
                });
                this.$store.commit('alert/setAlert', '');
            }
        },
    },
};
